/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementGetNewEventNumberResponse } from './MemberManagementGetNewEventNumberResponse';

export type MemberManagementGetNewEventNumberResponseApiRespoonse = {
    data?: MemberManagementGetNewEventNumberResponse;
    status?: MemberManagementGetNewEventNumberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementGetNewEventNumberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

